import { TGetProducts } from "@/types/productv2";
import ProductsFeed from "./products-feed";
import { TGetCategoryDataResponseDTO, TGetCategoryProductsResponseDTO } from "@/types/dto/category.dto";

const ProductsTab = ({
	products,
	filterRegions,
}: {
	products?: TGetProducts | TGetCategoryProductsResponseDTO;
	filterRegions?: TGetCategoryDataResponseDTO["productFilterRegions"];
}) => {
	return <ProductsFeed productsData={products} filterRegions={filterRegions} />;
};

export default ProductsTab;
